import {
  Container,
  CardContainer,
  CMdExpandMore,
  CardTitle,
  MedicalCard,
  MedicalSearch,
  MedicalTab,
  Table,
} from "../../../style/Prescription";
import UpArrow from "../../../assets/AssetArrow.png";
import SideImg from "../../../assets/Pmc/Ads/Asset-20.png";
import FormControl from "@material-ui/core/FormControl";
import { CustomDiv } from "../../../style/shared";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { Button, ButtonGrey } from "../../../style/Button";
import { FaRegEdit } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import PmsBilling from "../PendingRx/Billing/Billing";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Medication from "./Medication";
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import moment from "moment";
import "./select.css";
import "./Billing/Bill.css";
import { subject } from "../../../service";
import { verifyAuth } from "../../../authverify";
import { ModalButton } from "../../../style/ModalButton";
import TitlDollar from "../../../assets/tiltdollar.png";
import TitlDollarGrey from "../../../assets/dollargrey_tilt.png";
import { Image2 } from "../../../style/Logo";
import styled from "styled-components";
import { CustomLinkBut } from "../../../style/Dashboard";
import { useLocation, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { MedicationCard } from "../../Prescription/Prescription";
import { Checkbox, Grid } from "@material-ui/core";
// import PrimeraCreative from "../NewCreatives/PrimeraCreative/PrimeraCreative";
// import MedizenCreative from "../NewCreatives/MedizenCreative/MedizenCreative";
// import { elementAt } from "rxjs";
// import PrimeraVerticalAd from "../../assets/Ads/PrimeraV.jpg";
// import MedizenVerticalAd from "../../assets/Ads/MedizenV.jpg";
const Card = (props) => {
  return (
    <CardContainer>
      <CardTitle>{props.name}</CardTitle>
      <CMdExpandMore size="25px" />
    </CardContainer>
  );
};
const Paper = styled.div`
  width: 100%;
  min-height: 45px;
  margin-bottom: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border: 1px solid #c5c5c5;
  border-radius: 7px;
  font-size: 13px;
  font-weight: 500;
`;
const PendingRx = () => {
  const [imgsrc, setImgsrc] = useState("Ads/Vertical.jpeg");
  const history = useHistory();
  const location = useLocation();
  const match = useParams();

  const MedizenFormDetails = {
    medicationName: "Medizen",
    amount: "NA",
    dosageForm: "Tablet",
    route: "orally",
    frequency: "Twice a day",
    patientDirection: `Day 1: Start with 2 tablets stat
    Day 2 onwards: Take 1 tablet orally 2 times a day`,
    daysSupply: "30",
    dispenseAmount: "50 Tablet",
    pharmacyNote: "60mg/day, 2 tab/day only",
    alternativeMedication: "Plavix MG Oral Tablet",
    imageHeader: "Ads/Horizontal1.jpeg",
    imageLeft: "Ads/Vertical1.jpeg",
    discount: true,
    price: "9.33",
    "Order Status": "New"
  }
  useEffect(() => {
    const rmedval = JSON.parse(window.sessionStorage.getItem("med"));
    if (rmedval) setImgsrc(rmedval.imageLeft);
  }, []);

  const logChildValue = (value) => {
    history.push({
      pathname: "/People/billing",
      state: value,
    });
  };

  const handleOnClickMed = () => {
    history.push("/People/Pharmacy");
  };

  let data = JSON.parse(window.sessionStorage.getItem("medication"));

  if (!data) {
    window.sessionStorage.setItem("medication", JSON.stringify(MedizenFormDetails))
  }
  data = JSON.parse(window.sessionStorage.getItem("medication"))

  const randValue = parseInt(window.sessionStorage.getItem("rValue"));
  console.log(data, "data");

  const nextButtonHandler = () => {
    history.push("/Pmc/pricing")
  }

  if (!data) {
    window.sessionStorage.setItem("medication", JSON.stringify(MedizenFormDetails))
  }
  return (
    <>
      <Grid container className="billing-page">
        <Grid item md={12} lg={9} xs={12}>
          <Container>
            <Grid container>
              <Grid item xs={12} md={3}>
                <div className="paddingRight-30 pending-side-tabs">
                  <Paper
                    style={{
                      color: "#4678ED",
                      fontWeight: 600,
                      fontSize: "15px",
                      fontFamily: "work sans",
                      maxWidth: "100%",
                      width: "100%",
                      padding: "0px 15px",
                    }}
                  >
                    New Drug Prescribed{" "}
                    <img
                      src={UpArrow}
                      style={{
                        marginLeft: "auto",
                        marginTop: "0px",
                        width: "13.5px",
                      }}
                    />
                  </Paper>
                  <Paper
                    style={{
                      color: "#606060",
                      fontSize: "15px",
                      fontWeight: 600,
                      fontFamily: "work sans",
                      maxWidth: "100%",
                      width: "100%",
                      padding: "0px 15px",
                    }}
                  >
                    Medication history{" "}
                    <img
                      src={UpArrow}
                      style={{
                        marginLeft: "auto",
                        marginTop: "0px",
                        width: "13.5px",
                        transform: "rotate(180deg)",
                      }}
                    />
                  </Paper>
                </div>
              </Grid>
              <Grid item xs={12} md={9}>
                <PmsBilling />
              </Grid>
            </Grid>
          </Container>
          <div className="billingSignForm">
            <section
              class=" mt-3 custom-radius border border-secondary "
              style={{
                paddingBottom: "0px !important",
                backgroundColor: "white",
              }}
            >

              <nav class="navbar navbar-expand-lg   navbar-dark theme-color     p-1  ">
                <a
                  class="navbar-brand  ms-4 fw-bolder"
                  style={{
                    fontSize: "15.5px",
                    fontWeight: 600,
                    fontFamily:
                      "work sans",
                  }}
                  href="#"
                >
                  Sig Information
                </a>
              </nav>

              <div class="d-flex justify-content-evenly p-2 pt-4 flex-wrap-mob marginTabs">
                <button
                  type="button"
                  class="btn text-dark rounded-2 theme-font"
                  style={{
                    backgroundColor: "#e6e6e6",
                    fontFamily:
                      "work sans",
                    width: "100%",
                    fontSize: "14.13px",
                    fontWeight: 600,
                    color: "#58595B",
                  }}
                >
                  Action
                </button>
                <button
                  type="button"
                  class="btn text-dark rounded-2 theme-font"
                >
                  Amount
                </button>
                <button
                  type="button"
                  class="btn text-dark rounded-2 theme-font"
                >
                  Dosage Form
                </button>
                <button
                  type="button"
                  class="btn text-dark rounded-2 theme-font"
                >
                  Route
                </button>
                <button
                  type="button"
                  class="btn text-dark rounded-2 theme-font"
                >
                  Frequency
                </button>
              </div>
              <div
                class="d-flex justify-content-evenly p-2  flex-wrap-mob marginTabs"
                style={{ marginTop: "15px" }}
              >
                <select
                  name=""
                  id=""
                  class="form-select theme-font"
                  aria-label="Default select example"
                >
                  <option value="">Take</option>
                  <option value=""></option>
                </select>
                <select
                  name=""
                  id=""
                  class="form-select theme-font"
                >
                  <option value="">{data.amount}</option>
                </select>
                <select
                  name=""
                  id=""
                  class="form-select theme-font"
                >
                  <option value="">{data.dosageForm}</option>
                </select>
                <select
                  name=""
                  id=""
                  class="form-select theme-font"
                >
                  <option value="">{data.route}</option>
                </select>
                <select
                  name=""
                  id=""
                  class="form-select theme-font"
                >
                  <option value="">{data.frequency}</option>
                </select>
              </div>
              <div className="mb-3 p-4" style={{ marginTop: "7px" }}>
                <Grid container className="mb-4">
                  <Grid item md={2} xs={12}>
                    <label
                      for="add"
                      className=" theme-font"
                      style={{
                        maxWidth: "max-content",
                        fontWeight: 600,
                        fontFamily:
                          "work sans",
                        color: "#58595B",
                        fontSize: "14.13px",
                        paddingRight: "0px",
                      }}
                    >
                      Addtional Direction:
                    </label>
                  </Grid>
                  <Grid item md={10} xs={12}>
                    <input
                      style={{
                        maxWidth: " 100%",
                        minWidth: " 100%",
                        marginLeft: "0px",
                        fontFamily:
                          "work sans",
                        fontSize: "14.13px",
                        fontWeight: 600,
                        color: "#58595B",
                      }}
                      type="text"
                      class="form-control theme-font "
                      id="add"
                      value=""
                    />
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item md={6} xs={12}>
                    <Grid container >
                      <Grid item md={4} xs={12}>
                        <label
                          class="theme-font"
                          style={{
                            maxWidth: "100%",
                            fontWeight: 600,
                            fontFamily:
                              "work sans",
                            color: "#58595B",
                            fontSize: "14.13px",
                            paddingRight: "0px",
                          }}
                        >
                          Patient Direction: :
                        </label>
                      </Grid>
                      <Grid item md={8} xs={12}>
                        <textarea
                          style={{
                            maxWidth: "100%",
                            minWidth: "fit-content",
                            fontFamily:
                              "work sans",
                            fontSize: "14.13px",
                            fontWeight: 600,
                            color: "#58595B",
                          }}
                          name=""
                          id=""
                          cols="30"
                          rows="5"
                          class="form-control theme-font"
                        >
                          {data.patientDirection}
                        </textarea>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <div class="  mt-0 ms-1">
                      <Grid container className="mb-4">
                        <Grid md={4} lg={3} xs={12}>
                          <label
                            for=""
                            class="text-secondary   theme-font  p-2"
                            style={{
                              maxWidth: "max-content",
                              fontWeight: 600,
                              fontFamily:
                                "work sans",
                              color: "#58595B",
                              fontSize: "14.13px",
                              paddingRight: "0px",
                            }}
                          >
                            Day Supply:
                          </label>
                        </Grid>
                        <Grid md={8} lg={9} xs={12}>
                          <input
                            style={{
                              display: "inline",
                              fontSize: "12.7px",
                              fontFamily:
                                "work sans",
                              fontSize: "14.13px",
                              fontWeight: 600,
                              color: "#58595B",
                            }}
                            type="text"
                            class="form-control"
                            value={data.patientDirection}
                          />
                        </Grid>
                      </Grid>
                      <Grid container  className="mb-3">
                        <Grid md={4} lg={3} xs={12}>
                          <label
                            for=""
                            class="text-secondary   theme-font  p-2"
                            style={{
                              maxWidth: "max-content",
                              fontWeight: 600,
                              fontFamily:
                                "work sans",
                              color: "#58595B",
                              fontSize: "14.13px",
                              paddingRight: "0px",
                            }}
                          >
                            Dispence Amount:
                          </label>
                        </Grid>
                        <Grid md={8} lg={9} xs={12}>
                          <input
                            style={{
                              display: "inline",
                              fontSize: "12.7px",
                              fontFamily:
                                "work sans",
                              fontSize: "14.13px",
                              fontWeight: 600,
                              color: "#58595B",
                            }}
                            type="text"
                            class="form-control"
                            value={data.dispenseAmount}
                          />
                        </Grid>
                      </Grid>

                    </div>
                  </Grid>
                </Grid>
                <Grid container className="mt-4 mb-4">
                  <Grid item md={2} xs={12}>
                    <label
                      class=" theme-font"
                      style={{
                        maxWidth: "max-content",
                        fontWeight: 600,
                        fontFamily:
                          "work sans",
                        color: "#58595B",
                        fontSize: "14.13px",
                        paddingRight: "0px",
                      }}
                    >
                      Problem/Dx:
                    </label>

                  </Grid>
                  <Grid md={10} xs={12}>
                    <select
                      style={{
                        maxWidth: " 100%",
                        minWidth: " 100%",
                        fontFamily:
                          "work sans",
                        fontSize: "14.13px",
                        fontWeight: 600,
                        color: "#58595B",
                      }}
                      name=""
                      id=""
                      class="form-select theme-font"
                    >
                      <option value="">1</option>
                    </select>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid md={6} xs={12}>
                    <Grid container>
                      <Grid md={4} xs={12}>
                        <label
                          class=" theme-font"
                          style={{
                            maxWidth: "max-content",
                            fontWeight: 600,
                            fontFamily:
                              "work sans",
                            color: "#58595B",
                            fontSize: "14.13px",
                            paddingRight: "0px",
                          }}
                        >
                          Pharmacy Notes:
                        </label>
                      </Grid>
                      <Grid md={8} xs={12}>
                        <textarea
                          style={{
                            maxWidth: "100%",
                            minWidth: "fit-content",
                            fontFamily:
                              "work sans",
                            fontSize: "14.13px",
                            fontWeight: 600,
                            color: "#58595B",
                          }}
                          name=""
                          id=""
                          cols="30"
                          rows="3"
                          class="form-control theme-font"
                        >
                          {data.pharmacyNote}
                        </textarea>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid md={6} xs={12} className="p-2">
                    <Checkbox
                      style={{ padding: "0px", margin: "5px" }}
                      type="checkbox"
                      value=""
                    // onChange={() =>
                    //   this.setState({ check2: !this.state.check2 })
                    // }
                    />
                    <label
                      for=""
                      class="text-secondary   theme-font"
                      style={{
                        maxWidth: "max-content",
                        fontWeight: 600,
                        color: "#58595B",
                        fontSize: "14.13px",
                        paddingRight: "0px",
                        fontFamily:
                          "work sans",
                      }}
                    >
                      Store Sig & Add to Prescriber’s List
                    </label>
                    <div>
                      <Checkbox
                        style={{ padding: "0px", margin: "5px" }}
                        className="clickable2"
                        type="checkbox"
                        value=""
                      // onChange={() =>
                      //   this.setState({ check3: !this.state.check3 })
                      // }
                      />
                      <label
                        for=""
                        class="text-secondary   theme-font"
                        style={{
                          maxWidth: "max-content",
                          fontWeight: 600,
                          color: "#58595B",
                          fontSize: "14.13px",
                          paddingRight: "0px",
                          fontFamily:
                            "work sans",
                        }}
                      >
                        DAW/DNS
                      </label>
                    </div>
                  </Grid>
                </Grid>
              </div>
              <div class="mb-0    row">
                <nav
                  class="navbar navbar-expand-lg navbar-dark theme-color p-1 mt-2"
                  style={{
                    marginLeft: "0px",
                    marginTop: "7px",
                    minWidth: "100.4%",
                  }}
                >
                  <a
                    class="navbar-brand  ms-4 fw-bold"
                    href="#"
                    style={{
                      fontSize: "15.5px",
                      fontFamily:
                        "work sans",
                      fontWeight: 600,
                    }}
                  >
                    Alternative Medication
                  </a>
                </nav>

                <nav
                  class="navbar navbar-expand-lg border    navbar-primary bg-white "
                  style={{ marginLeft: "-16px", minWidth: "100.3%" }}
                >
                  <a
                    style={{
                      fontSize: "17px",
                      fontWeight: 600,
                      fontFamily: "work sans",
                    }}
                    class="navbar-brand  ms-4"
                    href="#"
                  >
                    {data.alternativeMedication}
                  </a>

                  <div
                    class="collapse navbar-collapse"
                    id="navbarNav"
                    style={{ marginRight: "35px" }}
                  >
                    <ul
                      class="navbar-nav ms-auto "
                      style={{ fontSize: "12px", color: "#606060" }}
                    >
                      <li class="nav-item" style={{ padding: 5 }}>
                        <b
                          style={{
                            fontWeight: 700,
                            fontFamily:
                              "work sans",
                          }}
                        >
                          Type:{" "}
                        </b>{" "}
                        <span
                          class="text-secondary"
                          style={{
                            fontWeight: 500,
                            fontFamily:
                              "work sans",
                          }}
                        >
                          Brand Rx
                        </span>
                      </li>
                      <li class="nav-item" style={{ padding: 5 }}>
                        <b
                          style={{
                            fontWeight: 700,
                            fontFamily:
                              "work sans",
                          }}
                        >
                          Formulary:{" "}
                        </b>{" "}
                        <span
                          class="text-secondary"
                          style={{
                            fontWeight: 500,
                            fontFamily:
                              "work sans",
                          }}
                        >
                          Un
                        </span>
                      </li>
                      <li
                        class="nav-item"
                        style={{
                          padding: 5,
                          fontWeight: 500,
                          fontFamily:
                            "work sans",
                        }}
                      >
                        View Coverage
                      </li>
                    </ul>{" "}
                  </div>
                </nav>
                <nav
                  class="navbar navbar-expand-lg border   navbar-primary bg-white "
                  style={{
                    marginLeft: "-16px",
                    minWidth: "100.3%",
                    borderBottom: "none",
                  }}
                >
                  <div class="collapse navbar-collapse" id="navbarNav">
                    <ul
                      class="navbar-nav offset-10 position-relative"
                      style={{ fontSize: "13px", right: "0px" }}
                    >
                      <li class="nav-item " style={{ marginTop: "-2px" }}>
                        <Checkbox
                          className="alternativeMedication"
                          type="checkbox"
                          value=""
                        // disabled={
                        //   alternativeMedication === "NA"
                        // }
                        // onChange={
                        //   alternativeMedication !== "NA"
                        //     ? () =>
                        //       this.setState({ check4: !this.state.check4 })
                        //     : () => { }
                        // }
                        />
                        {/* onChange={this.handleChange} */}
                      </li>
                      <li class="nav-item ms-2">
                        <div
                          class="nav-link text-dark"
                          style={{
                            width: "32px",
                            height: "35px",
                            marginTop: "-3px",
                            fontSize: "20px",
                          }}
                        >
                          <i
                            class="far fa-money-bill-alt"
                            style={{
                              color: "#e7e7e7",
                            }}
                          ></i>
                        </div>
                      </li>
                      <li class="nav-item  ">
                        <div
                          class="nav-link "
                          style={{
                            color: "#e7e7e7",
                            fontSize: "10px",
                            fontWeight: 500,
                            marginLeft: "7px",
                            fontFamily:
                              "work sans",
                          }}
                        >
                          Coupon/Guide <br />
                          Available
                        </div>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>
            </section>
            <div
              class="col-md-12 mt-3 pricingButtons "
              style={{
                paddingBottom: "20px",
                textAlign: "right",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              <Button
                height="fit-content"
                className="billing-btn-outline md-ml-15"
              >
                Close
              </Button>
              <Button
                height="fit-content"
                className="billing-btn-primary"
                onClick={nextButtonHandler}
              >
                Next
              </Button>
            </div>
          </div>
        </Grid>
        <Grid item md={12} lg={3} xs={12} className="rightIframe">
          <img src={SideImg} />
        </Grid>
      </Grid>
    </>
  );
}

export default PendingRx
